import Vant from 'vant'
import 'vant/lib/index.css'
import '@/styles/brand-vant.css' // Vant4 品牌主题层(Neon Chrome)
import {
  showToast,
  showSuccessToast,
  showFailToast,
  showLoadingToast,
  closeToast,
  showConfirmDialog
} from 'vant'

const createToastCompat = () => {
  const toast = (options) => showToast(options)
  toast.success = (options) => showSuccessToast(options)
  toast.fail = (options) => showFailToast(options)
  toast.loading = (options) => showLoadingToast(options)
  toast.clear = () => closeToast()
  return toast
}

const createDialogCompat = () => {
  return {
    confirm(options) {
      return showConfirmDialog(options)
    },
    alert(options) {
      return showConfirmDialog({
        showCancelButton: false,
        ...options
      })
    }
  }
}

export function setupVant(app) {
  app.use(Vant)
  app.config.globalProperties.$toast = createToastCompat()
  app.config.globalProperties.$dialog = createDialogCompat()
}
